import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const FaturaBilgileri = () => {
  document.title = "Fatura Bilgileri | HarmanaGEL";

  const [faturalar, setFaturalar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [detailModal, setDetailModal] = useState(false);
  const [selectedFatura, setSelectedFatura] = useState(null);

  const fetchFaturalar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/FATURA_BILGILERI?$top=500&$orderby=GUNCELLEME_TARIHI desc&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setFaturalar(result.value);
    } catch (err) {
      setError("Fatura bilgileri yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFaturalar();
  }, []);

  const tipBadge = (tip) => {
    return <Badge color={tip === "Bireysel" ? "info" : "primary"}>{tip || "-"}</Badge>;
  };

  const handleViewDetail = (fatura) => {
    setSelectedFatura(fatura);
    setDetailModal(true);
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Kullanıcı",
      accessorKey: "KULLANICILAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : <span className="text-muted">Kullanıcı #{cell.row.original.KULLANICI_ID}</span>;
      },
    },
    {
      header: "Tip",
      accessorKey: "TIP",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => tipBadge(cell.getValue()),
    },
    {
      header: "Ad Soyad / Firma",
      accessorKey: "AD_SOYAD",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => {
        const f = cell.row.original;
        return (
          <div>
            <div className="fw-medium">{f.AD_SOYAD || f.FIRMA_UNVANI || "-"}</div>
            {f.FIRMA_UNVANI && <small className="text-muted">{f.AD_SOYAD}</small>}
          </div>
        );
      },
    },
    {
      header: "Vergi No",
      accessorKey: "VERGI_NO",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => <span className="font-monospace small">{cell.getValue() || "-"}</span>,
    },
    {
      header: "İl / İlçe",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => {
        const f = cell.row.original;
        return <span>{f.IL} / {f.ILCE}</span>;
      },
    },
    {
      header: "Güncelleme",
      accessorKey: "GUNCELLEME_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleDateString("tr-TR") : "-";
      },
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const f = cellProps.row.original;
        return (
          <Button color="info" size="sm" outline onClick={() => handleViewDetail(f)}>
            <i className="bx bx-detail" />
          </Button>
        );
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Fatura Bilgileri" />

          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Fatura Bilgileri</h4>
                    <Button color="primary" size="sm" onClick={fetchFaturalar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={faturalar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Fatura ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal isOpen={detailModal} toggle={() => setDetailModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setDetailModal(false)}>
          Fatura Detayı
        </ModalHeader>
        <ModalBody>
          {selectedFatura && (
            <table className="table table-sm table-bordered">
              <tbody>
                <tr><th>Tip</th><td>{tipBadge(selectedFatura.TIP)}</td></tr>
                <tr><th>Ad Soyad</th><td>{selectedFatura.AD_SOYAD || "-"}</td></tr>
                <tr><th>TC Kimlik No</th><td>{selectedFatura.TC_KIMLIK_NO || "-"}</td></tr>
                <tr><th>Firma Unvanı</th><td>{selectedFatura.FIRMA_UNVANI || "-"}</td></tr>
                <tr><th>Vergi Dairesi</th><td>{selectedFatura.VERGI_DAIRESI || "-"}</td></tr>
                <tr><th>Vergi No</th><td>{selectedFatura.VERGI_NO || "-"}</td></tr>
                <tr><th>Adres</th><td>{selectedFatura.ADRES || "-"}</td></tr>
                <tr><th>İl / İlçe</th><td>{selectedFatura.IL} / {selectedFatura.ILCE}</td></tr>
                <tr><th>Kullanıcı</th><td>{selectedFatura.KULLANICILAR?.AD_SOYAD || "-"}</td></tr>
                <tr><th>Güncelleme Tarihi</th><td>{selectedFatura.GUNCELLEME_TARIHI ? new Date(selectedFatura.GUNCELLEME_TARIHI).toLocaleDateString("tr-TR") : "-"}</td></tr>
              </tbody>
            </table>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setDetailModal(false)}>Kapat</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default FaturaBilgileri;
